import { render } from "./FontFormatMenu.vue?vue&type=template&id=73c7298a"
import script from "./FontFormatMenu.vue?vue&type=script&lang=js"
export * from "./FontFormatMenu.vue?vue&type=script&lang=js"

import "./FontFormatMenu.vue?vue&type=style&index=0&id=73c7298a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__